import basicAppConfig from "../../../infra/constants/basicAppConfig";
import getModelTierDisplayRole from "./getModelTierDisplayRole";
import useUserPlanName from "./useUserPlanName";
/**
 * Returns the brand-specific, translated plan name for a CMS model `level`.
 *
 * Display only. Do not use this for grouping, gating, or badge colors — those
 * must keep the raw CMS `level` so SecretMate can still match
 * SubscriptionTiers.PREMIUM ("I'm All In") while showing "Premium".
 */
const useModelTierDisplayName = ({ level, applicationId = basicAppConfig.applicationId }) => {
    const displayRole = getModelTierDisplayRole({ level, applicationId });
    const planName = useUserPlanName(displayRole);
    if (!level) {
        return "";
    }
    if (!displayRole) {
        return level;
    }
    return planName;
};
export default useModelTierDisplayName;
